@if (projectView$ | async; as viewMaybe) {
  @if (viewMaybe; as view) {
    <article class="project-detail">
      <div class="detail-nav">
        <a mat-button routerLink="/portfolio" class="back-link">
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
          Portfolio
        </a>
        @if (isAdmin$ | async) {
          <button mat-button color="primary" type="button" (click)="editProject(view.project.id)">
            <mat-icon aria-hidden="true">edit</mat-icon>
            Edit project
          </button>
        }
      </div>

      @if (view.carouselImages.length) {
        <app-project-image-carousel
          [images]="view.carouselImages"
          [alt]="view.project.name"
        />
      }

      <mat-card class="detail-card">
        <mat-card-header>
          <img mat-card-avatar class="detail-avatar" [src]="profileAvatarSrc" alt="" />
          <mat-card-title class="title-row">
            <span>{{ view.project.name }}</span>
            @if (view.project.visibility === Visibility.hidden) {
              <span class="private-badge">Private</span>
            }
            @if (view.project.visibility === Visibility.personal) {
              <span class="private-badge personal-badge">Personal</span>
            }
            <span class="spacer"></span>
            @if (view.project.status === Status.archived) {
              <mat-icon class="finished" [matTooltip]="view.project.status" fontIcon="done"></mat-icon>
            }
            @if (view.project.status === Status.active) {
              <mat-icon class="active" [matTooltip]="view.project.status" fontIcon="cached"></mat-icon>
            }
            @if (view.project.status === Status.on_hold) {
              <mat-icon class="on-hold" [matTooltip]="view.project.status" fontIcon="blocked"></mat-icon>
            }
            @if (view.project.status === Status.planned) {
              <mat-icon class="planned" [matTooltip]="view.project.status" fontIcon="event_note"></mat-icon>
            }
          </mat-card-title>
          <mat-card-subtitle>{{ view.project.short_description }}</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          @if (formatDateRange(view.project)) {
            <p class="meta-dates">{{ formatDateRange(view.project) }}</p>
          }

          @if (view.project.categories?.length) {
            <div class="tags tags--categories">
              @for (cat of view.project.categories; track cat) {
                <mat-chip disabled class="category-chip">{{ cat }}</mat-chip>
              }
            </div>
          }

          @if (view.project.tags?.length) {
            <div class="tags">
              @for (tag of view.project.tags; track tag) {
                <mat-chip disabled>{{ tag }}</mat-chip>
              }
            </div>
          }

          @if (view.project.long_description) {
            <div class="long-desc">{{ view.project.long_description }}</div>
          }
        </mat-card-content>
      </mat-card>
    </article>
  } @else {
    <p class="state-msg">Loading project…</p>
  }
} @else {
  <p class="state-msg">Loading project…</p>
}
